import { topicList,topicProductList } from '../../api/promotions'

// initial state
const state = {
	promotionProducts: []
}

// mutations
const mutations = {
	savePromotionProducts(state, data) {
		state.promotionProducts = data
	}
}

// actions 
const actions = {
	fetchPromotionProduct({ commit, state }, params) {
		return new Promise((resolve, reject) => {
			topicList(params.display_area,params.page, params.per_page).then(
				response => {
					if (response) {
						commit('savePromotionProducts', response.topic)
					}
					resolve(response)
				},
				error => {
					reject(error)
				}
			)
		})
	}
}

export default {
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/promotions.js